import * as React from 'react';

import IContainerContextProps from './Interfaces/IContainerContextProps';
import fallbackContainerContextValue from './Util/fallbackContainerContextValue';

/**
 * A context provided by every container component in the tree of focusable nodes. Each
 * `ContainerContext` cascades downwards until it is overridden by the context of a nested container
 * within it and so on.
 *
 * The context is used to provide the ID of the nearest parent container, thus mapping the
 * relationship between all nodes in the tree.
 */

const ContainerContext = React.createContext<IContainerContextProps>(fallbackContainerContextValue);

export default ContainerContext;
